export const ACCOUNT_NUMBER_REGEXP = /A-[A-Z\d]{8}/
